import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import clsx from "clsx";

import { login } from "../redux/AuthCRUD";
import * as auth from "../redux/AuthRedux";

const loginSchema = Yup.object().shape({
	identifier: Yup.string()
		.min(11, "Mínimo de 11 caracteres")
		.max(11, "Máximo de 11 caracteres")
		.required("CPF é obrigatório"),
	password: Yup.string()
		.min(3, "Mínimo de 3 caracteres")
		.max(50, "Máximo de 50 caracteres")
		.required("Senha é obrigatória"),
});

const initialValues = {
	identifier: "",
	password: "",
};

export function Login() {
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const formik = useFormik({
		initialValues,
		validationSchema: loginSchema,
		onSubmit: (values, { setStatus, setSubmitting }) => {
			setLoading(true);
			setTimeout(() => {
				login(values.identifier, values.password)
					.then(({ data: { token } }) => {
						setLoading(false);
						dispatch(auth.actions.login(token));
					})
					.catch(() => {
						setLoading(false);
						setSubmitting(false);
						setStatus("CPF ou senha inválidos");
					});
			}, 1000);
		},
	});

	return (
		<form
			className="form w-100"
			onSubmit={formik.handleSubmit}
			noValidate
			id="kt_login_signin_form"
		>
			<div className="fv-row mb-10">
				<label className="form-label fs-6 fw-bolder text-dark sr-only">Email</label>
				<input
					placeholder="CPF"
					autoComplete="cpf"
					{...formik.getFieldProps("email")}
					className={clsx(
						"form-control form-control-lg",
						{ "is-invalid": formik.touched.identifier && formik.errors.identifier },
						{
							"is-valid": formik.touched.identifier && !formik.errors.identifier,
						}
					)}
					type="text"
					name="identifier"
				/>
				{formik.touched.identifier && formik.errors.identifier && (
					<div className="fv-plugins-message-container">
						<span role="alert">{formik.errors.identifier}</span>
					</div>
				)}
			</div>

			<div className="fv-row mb-3">
				<div className="d-flex justify-content-between mt-n5">
					<div className="w-100 d-flex flex-stack mb-2">
						<label className="form-label fw-bolder text-dark fs-6 mb-0 sr-only">
							Senha
						</label>
					</div>
				</div>
				<input
					placeholder="Senha"
					type="password"
					autoComplete="off"
					{...formik.getFieldProps("password")}
					className={clsx(
						"form-control form-control-lg",
						{
							"is-invalid": formik.touched.password && formik.errors.password,
						},
						{
							"is-valid": formik.touched.password && !formik.errors.password,
						}
					)}
				/>
				{formik.touched.password && formik.errors.password && (
					<div className="fv-plugins-message-container">
						<div className="fv-help-block">
							<span role="alert">{formik.errors.password}</span>
						</div>
					</div>
				)}
			</div>

			<div className="d-flex justify-content-end gap-3 fs-base fw-semibold mb-8">
				<Link to="/auth/esqueci-a-senha" className="link-primary">
					Esqueceu a senha ?
				</Link>
			</div>

			<div className="text-center">
				<button
					type="submit"
					id="kt_sign_in_submit"
					className="btn btn-lg btn-primary w-100 mb-5"
					disabled={formik.isSubmitting || !formik.isValid}
				>
					{!loading && <span className="indicator-label">Entrar</span>}
					{loading && (
						<span className="indicator-progress" style={{ display: "block" }}>
							Por favor, aguarde...
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
						</span>
					)}
				</button>
			</div>

			<div className="text-center mt-5 fw-bold">
				<span className="text-muted">Não tem uma conta?</span>{" "}
				<Link to="/" className="opacity-75-hover text-primary me-1">
					Criar conta
				</Link>
			</div>
		</form>
	);
}
